import { ApiResult } from "common/models";
import { HttpClient } from "common/services/http-client.service";
import { withApiResponse } from "common/utils/rtk-query.util";
import { searchHubConfig } from "../config/search-hub.config";
import {
  HybridSearchRequest,
  SearchResultsPayload,
  HybridKgRequest,
  HybridKgResponse
} from "../models/search-hub.model";

export class SearchHubService extends HttpClient {
  public static hybridSearch(request: HybridSearchRequest) {
    const config = searchHubConfig.hybridSearch(request);
    return withApiResponse<SearchResultsPayload>(async () => {
      const response = await this.invokeApi<SearchResultsPayload>(config);
      return new ApiResult<SearchResultsPayload>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }

  public static hybridKg(request: HybridKgRequest) {
    const config = searchHubConfig.hybridKg(request);
    return withApiResponse<HybridKgResponse>(async () => {
      const response = await this.invokeApi<HybridKgResponse>(config);
      return new ApiResult<HybridKgResponse>(
        response.value,
        response.statusCode,
        ...response.errors
      );
    });
  }
}
